import { Input, Autocomplete, AutocompleteItem } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

const FilterData = ({ table, initialFilters = {}, filterOptions }) => {
    const { types } = filterOptions;
    const { pending, setPending, isOpen, apply, clear } = table.filterPanel;

    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            <Input
                label="Nama"
                placeholder="Cari nama..."
                value={pending.name || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({ ...prev, name: val }))
                }
                variant="flat"
                isClearable
            />
            <Autocomplete
                label="Tipe"
                placeholder="Pilih Tipe"
                selectedKey={
                    pending.transaction_category_type_id
                        ? String(pending.transaction_category_type_id)
                        : null
                }
                onSelectionChange={(key) =>
                    setPending((prev) => ({
                        ...prev,
                        transaction_category_type_id: key || "",
                    }))
                }
                variant="flat"
                isClearable
            >
                {(types || []).map((t) => (
                    <AutocompleteItem key={String(t.value)} value={t.value}>
                        {t.title}
                    </AutocompleteItem>
                ))}
            </Autocomplete>
        </FilterCard>
    );
};

export default FilterData;
